// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app';

// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDuz1esHvu-s9VsMLS5CXabIb_ZKxMvntI',
  authDomain: 'graphics-research-tree-test.firebaseapp.com',
  databaseURL: 'https://graphics-research-tree-test.firebaseio.com',
  projectId: 'graphics-research-tree-test',
  storageBucket: 'graphics-research-tree-test.appspot.com',
  messagingSenderId: '481722890754',
  appId: '1:481722890754:web:4af1055020fece8bd6051b',
  measurementId: 'G-LSK3EDNW9Z'
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export default firebase;
